import { clsx } from "clsx";
import "./Button.scss";

interface IButtonProps extends React.ComponentPropsWithRef<"button">{
  variant?: "primary" | "secondary" | "tertiary";
  size?: "l" | "m" | "s" | "xs";
  children: React.ReactNode;
  round?: boolean;
  fullWidth?: boolean;
}

export const Button: React.FC<IButtonProps> = ({
  variant = "primary",
  size = "l",
  children,
  round,
  fullWidth,
  className,
  ...restProps
}) => {
  return (
    <button
      className={clsx(
        "Button",
        `Button_${variant}`,
        `Button_${size}`,
        round && "Button_isRound",
        fullWidth && "Button_fullWidth",
        className
      )}
      {...restProps}
    >
      <div className="Button-Wrap">{children}</div>
    </button>
  );
};

